import {
  CheckCircleFilled,
  FilterOutlined,
  PlusOutlined,
  UndoOutlined,
} from "@ant-design/icons";
import { Tooltip, Button, Badge } from "antd";
import { Content } from "antd/lib/layout/layout";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import GetScalesFilterApi from "../../api/scales/GetScalesFilterApi";
import GetScalesTableApi from "../../api/scales/GetScalesTableApi";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import AddScaleModal from "../../components/modal/add/AddScaleModal";
import ScalesFilterModal from "../../components/modal/filters/ScalesFilterModal";
import PageLoader from "../../components/sub/PageLoader";
import ScalesTable from "../../components/tables/ScalesTable";
import { permissionAbility } from "../../helpers/permissionHelpers";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function Scales(props) {
  const [canStart, setCanStart] = useState(false);
  const [data, setData] = useState();
  const [tableLoading, setTableLoading] = useState(true);
  const [filterModal, setFilterModal] = useState(false);
  const [filterStatus, setFilterStatus] = useState(false);
  const [filterBy, setFilterBy] = useState();
  const [page, setPage] = useState(1);
  const [addModal, setAddModal] = useState(false);
  const proHeight = document.body.clientHeight;
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;

  useEffect(() => {
    getScales(1);
    setFilterBy({ name: "", type: "", status: "" });
  }, []);

  async function getScales(num) {
    setTableLoading(true);
    const apiResponse = await GetScalesTableApi(num , LIMIT_PER_PAGE);
    if (apiResponse.success) {
      setData(apiResponse.data);
      setCanStart(true);
      setTableLoading(false);
      setPage(num);
    }
  }

  async function getFilterScales(values, num) {
    setTableLoading(true);
    const apiResponse = await GetScalesFilterApi(
      values.name || "",
      values.type,
      values.status || "",
      num,
      LIMIT_PER_PAGE
    );
    if (apiResponse.success) {
      setData(apiResponse.data);
      setTableLoading(false);
      setFilterStatus(true);
      setFilterBy({
        name: values.name,
        type: values.type,
        status: values.status,
      });
      setPage(num);
    }
  }

  function changeTablePage(num) {
    if (filterStatus) {
      getFilterScales(filterBy, num);
    } else {
      getScales(num);
    }
  }

  function resetFilter() {
    getScales(1);
    setFilterStatus(false);
    setFilterBy({ name: "", type: "", status: "" });
  }

  const right = (
    <>
      <>
        <Tooltip title={"Reset"}>
          <Button
            disabled={!filterStatus}
            onClick={() => resetFilter()}
            className="mr-3"
          >
            <UndoOutlined />
          </Button>
        </Tooltip>
        <Tooltip title={"Filter"}>
          <Badge
            count={
              filterStatus ? (
                <CheckCircleFilled style={{ color: "#f5222d" }} />
              ) : (
                0
              )
            }
          >
            <Button onClick={() => setFilterModal(true)}>
              <FilterOutlined />
            </Button>
          </Badge>
        </Tooltip>
      </>
      {permissionAbility(userLevel, "scales", "add") && (
        <Tooltip placement="left" title={"Add Scale"}>
          <Button
            onClick={() => setAddModal(true)}
            className="ml-3"
            shape="circle"
            type="primary"
            icon={<PlusOutlined />}
          ></Button>
        </Tooltip>
      )}
    </>
  );

  const left = <div className="text-lg pri-font">{"Scales"}</div>;

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} right={right} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          {canStart ? (
            <ScalesTable
              data={data}
              loading={tableLoading}
              changePage={(num) => changeTablePage(num)}
              page={page}
            />
          ) : (
            <PageLoader />
          )}
        </div>
      </Content>
      <AddScaleModal
        visible={addModal}
        handleCancel={() => setAddModal(false)}
        handleOk={() => changeTablePage(1)}
      />
      <ScalesFilterModal
        visible={filterModal}
        handleCancel={() => setFilterModal(false)}
        handleOk={(values) => getFilterScales(values, 1)}
        filterBy={filterBy}
      />
    </>
  );
}

export default Scales;
